"use client"

import React, { ReactNode } from "react"
import { RWebShare } from "react-web-share"

export function ShareLink({ text, url, title, children }: { text: string; url: string; title: string; children: ReactNode }) {
  return (
    <RWebShare
      data={{
        text: text,
        url: url,
        title: title,
      }}>
      {children}
    </RWebShare>
  )
}
